import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Multiselect from '../../MultiSelect'
import Editor from '../../editor'

const CreateModal = ({ pages, handleRefresh, data }) => {
  const uploadImage = useUploadImage()
  const { page_id } = useParams()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [user] = useUserInfo()
  var axios = require('axios')
  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  const ToolTipTypes = [
    {
      label: 'New Tab',
      value: 'New Tab',
    },
    {
      label: 'Internal',
      value: 'Internal',

    },
    {
      label: 'Copy Button',
      value: 'Copy Button',

    },
    {
      label: 'GHL PATH',
      value: 'GHL PATH',

    },

  ]
  const imageOrVideoSelect = [
    {
      label: 'Image',
      value: 'Image',
    },
    {
      label: 'Video',
      value: 'Video',
    },
  ]
  const Positions = [
    {
      label: 'Top Left',
      value: 'Top Left',
    },
    {
      label: 'Bottom Left',
      value: 'Bottom Left',
    },
    {
      label: 'Top Right',
      value: 'Top Right',
    },
    {
      label: 'Bottom Right',
      value: 'Bottom Right',
    },
    {
      label: 'Center',
      value: 'Center',
    },
  ]
  const Directions = [
    {
      label: 'Left',
      value: 'Left',
    },
    {
      label: 'Right',
      value: 'Right',
    },
    {
      label: 'Top',
      value: 'Top',
    },
    {
      label: 'Bottom',
      value: 'Bottom',
    },
  ]
  const Selectors = [
    {
      label: 'Left',
      value: 'Left',
    },
    {
      label: 'Right',
      value: 'Right',
    },
    {
      label: 'Top',
      value: 'Top',
    },
    {
      label: 'Bottom',
      value: 'Bottom',
    },
  ]
  useEffect(async () => { }, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [toolTipType, setToolTipType] = useState({})
    const { id } = useParams()
    console.log(id, "id")
    const [imageOrVideo, setImageOrVideo] = useState({})
    const [content, setContent] = useState('')
    const [name, setName] = useState(data?.name || "");
    const [type, setType] = useState(data?.type || "");
    const [value, setValue] = useState(data?.value || "");

    const handleSubmit = async (e) => {
      e.preventDefault();
      setProcessing(true);

      const payload = {
        id: id,
        routes: [
          {
            name,
            type,
            value
          }
        ]
      };

      const { response } = await AppService.onboarding_list.update({
        // id: id,
        payload,
      });

      if (response) {
        setProcessing(false);
        onClose();
        handleRefresh();
      }
    };

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 600,
      height: 'auto',
      maxHeight: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Create Route
            </MDTypography>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput
                label="Name"
                name="name"
                fullWidth
                // value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </MDBox>

            <MDBox sx={{ fontSize: '15px' }}>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Type
              </MDTypography>
              <Multiselect
                data={ToolTipTypes}
                // edit_data={data?.type ? [{ label: data.type, value: data.type }] : []}
                isMulti={false}
                name="type"
                onChange={(e) => setType(e.value)}
              />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Action Value
              </MDTypography>
              <MDInput
                label="Value"
                name="value"
                fullWidth
                onChange={(e) => setValue(e.target.value)}
              />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Create
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton color="white" size="small" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
